module.exports = __webpack_public_path__ + "img/timmy-03.527baede.png";